import { until } from '@vueuse/core'

// Pages fire queries in onMounted independently of the layout's async client
// initialization (see default.vue), so client_data_endpoint can still be the
// '' default when the per-client GraphQL endpoint URL is built - that produces
// an invalid 'https://.<DATA_DOMAIN>/v1/graphql' request that silently fails.
// Wait for it to be populated first instead of firing against a broken host.
export async function waitForClientDataEndpoint (): Promise<void> {
  const { currentClient } = useCurrentClient()
  if (currentClient.value.client_data_endpoint) {
    return
  }
  await until(() => currentClient.value.client_data_endpoint).toBeTruthy({ timeout: 10000 })
}
